module.exports = __webpack_public_path__ + "static/media/img_inStore.9f05a481.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/home/images/img_inStore.jpg
// module id = 422
// module chunks = 4